import { addMethod, string } from 'yup';

addMethod(string, 'htmlContentMaxCharactersCount', function (maxCount: number, message: string) {
  return this.test('htmlContentMaxCharactersCount', function (value = '') {
    const virtualBody = document.createElement('body');
    virtualBody.innerHTML = value;

    const charactersCount = virtualBody?.textContent?.length ?? 0;

    if (charactersCount >= maxCount) {
      throw this.createError({
        path: `${this.path}`,
        message: message || `Characters count should be less than or equal to ${maxCount}.`,
      });
    }

    return true;
  });
});
